import { useLayoutEffect } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

function SyncWithDrillDown(props) {
  useLayoutEffect(() => {
    let root = am5.Root.new("combined-bullet-column-line");

    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: true,
        panY: true,
        wheelX: "panX",
        wheelY: "zoomX",
        layout: root.verticalLayout
      })
    );

    let data = [];
    for (let i = 0; i < 100; i++) {
      data.push({
        category: i,
        value1: Math.round(Math.random() * 100),
        value2: Math.round(Math.random() * 100)
      });
    }

    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        renderer: am5xy.AxisRendererX.new(root, {}),
        categoryField: "category"
      })
    );
    xAxis.data.setAll(data);

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {})
      })
    );

    let columnSeries = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Column Series",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "value1",
        categoryXField: "category"
      })
    );
    columnSeries.data.setAll(data);

    let lineSeries = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: "Line Series",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "value2",
        categoryXField: "category"
      })
    );
    lineSeries.data.setAll(data);

    lineSeries.bullets.push(() => {
      return am5.Bullet.new(root, {
        sprite: am5.Circle.new(root, {
          radius: 5,
          fill: lineSeries.get("fill")
        })
      });
    });

    chart.set("cursor", am5xy.XYCursor.new(root, {
      behavior: "zoomXY",
      xAxis: xAxis,
      yAxis: yAxis
    }));

    chart.set("scrollbarX", am5.Scrollbar.new(root, {
      orientation: "horizontal"
    }));

    chart.set("scrollbarY", am5.Scrollbar.new(root, {
      orientation: "vertical"
    }));

    let legend = chart.children.push(am5.Legend.new(root, {}));
    legend.data.setAll(chart.series.values);

    return () => {
      root.dispose();
    };
  }, []);

  return (
    <div id="combined-bullet-column-line" className="h-[500px] w-full"></div>
  );
}

export { SyncWithDrillDown };
